import React, { FC, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Container } from '@mui/material';
import { QUERY_PARAMS } from '../../constants/account-dashboard.constants';
import { useDashboard } from '../../contexts';
import { BannerCloseButtonComponent, BannerContent } from './components';
import { BannerContainer, BannerContentContainer } from './styled';

export const ThankYouBanner: FC = () => {
  const { account } = useDashboard();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isVisible, setIsVisible] = useState(false);

  // Set banner visibility based on query parameter
  useEffect(() => {
    const hasThankYouParam = searchParams.has(QUERY_PARAMS.THANK_YOU);
    setIsVisible(hasThankYouParam);
  }, [searchParams]);

  const handleClose = () => {
    setIsVisible(false);

    const newParams = new URLSearchParams(searchParams);
    newParams.delete(QUERY_PARAMS.THANK_YOU);
    setSearchParams(newParams);
  };

  if (!isVisible || !account) return null;

  return (
    <BannerContainer>
      <Container
        maxWidth="xl"
        sx={{ height: '100%', display: 'flex', alignItems: 'center' }}
      >
        <BannerContentContainer>
          <BannerContent tradingSystem={account.tradingSystem} />
        </BannerContentContainer>
      </Container>
      <BannerCloseButtonComponent onClose={handleClose} />
    </BannerContainer>
  );
};
